module.exports = __webpack_public_path__ + "img/10004.00af1be2.jpg";